module.exports = __webpack_public_path__ + "img/companyEle.1c9e3211.svg";